import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-uncommon-black pt-20" data-id="element-125">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-126">
        <img src="https://images.unsplash.com/photo-1543807535-eceef0bc6599?q=80&w=2940&auto=format&fit=crop" alt="Group of diverse friends sitting on a rooftop ledge overlooking the city skyline at sunset" className="w-full h-full object-cover opacity-60" data-id="element-127" />
        <div className="absolute inset-0 bg-gradient-to-t from-uncommon-black via-uncommon-black/70 to-transparent" data-id="element-128" />
        <div className="absolute inset-0 bg-gradient-to-r from-uncommon-black/80 via-transparent to-uncommon-black/80" data-id="element-129" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-130">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-131">
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-black text-white tracking-tighter mb-6 leading-tight" data-id="element-132">
            BE <span className="text-uncommon-gold" data-id="element-133">U</span>NCMMN.
            <br data-id="element-134" />
            LIVE <span className="text-uncommon-gold" data-id="element-135">U</span>NCMMN.
          </h1>

          <p className="text-lg md:text-xl text-gray-300 max-w-2xl mx-auto mb-10 font-light leading-relaxed" data-id="element-136">
            Premium tech, bold fashion, and lifestyle essentials for those who
            dare to stand out. Celebrate your individuality with gear that
            speaks your language.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-137">
            <Button variant="primary" data-id="element-138">Shop Now</Button>
            <Button variant="secondary" className="group" data-id="element-139">
              Explore Collections
              <ArrowRight className="ml-2 w-4 h-4 transition-transform group-hover:translate-x-1" data-id="element-140" />
            </Button>
          </div>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1,
      duration: 1
    }} className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex flex-col items-center gap-2" data-id="element-141">
        <span className="text-xs text-uncommon-gold uppercase tracking-widest" data-id="element-142">
          Scroll
        </span>
        <div className="w-[1px] h-12 bg-gradient-to-b from-uncommon-gold to-transparent" data-id="element-143" />
      </motion.div>
    </section>;
}